<template>
  <v-row dense no-gutters>
    <v-col cols="8">
      <ref-g-o-s-t2-f-t-table :value="selectedGOST" @input="onGOSTChange"/>
    </v-col>
    <v-col cols="4">
      <ref-g-o-s-t2-ft-card :g-o-s-t="selectedGOST.length ? selectedGOST[0] : null" :mode="'viewer'"/>
    </v-col>
    <ref-add-g-o-s-t2-f-t-dialog v-model="dlgShowAdd" :gost="selectedGOST.length ? selectedGOST[0] : null" @gostAdded="onGOSTChange" @gostUpdate="onGOSTChange"/>
    <sys-confirm-dialog :value="dlgShowConfirm" :message="'Подтвердите удаление'" :no-call-back="cancelConfirmDialog" :ok-call-back="doDeleteFT"/>
  </v-row>
</template>

<script>
import { UI_ADD_ACTION, UI_SET_ACTIONS, UI_SNACKBAR } from '@/store/actions/ui'
import RefGOST2FTTable from '@/components/modules/references/refGOST2FTTable'
import RefGOST2FtCard from '@/components/modules/references/cards/refGOST2FTCard'
import RefAddGOST2FTDialog from '@/components/modules/references/dialogs/refAddGOST2FTDialog'
import SysConfirmDialog from '@/components/common/dialogs/confirmDialog'
import axios from 'axios'
export default {
  name: 'refGOST2FTList',
  components: { SysConfirmDialog, RefAddGOST2FTDialog, RefGOST2FtCard, RefGOST2FTTable },
  props: ['accessKey'],
  data () {
    return {
      addAction: { text: 'Добавить элемент', actionType: 'Справочник ГОСТы по типам топлива', action: 'addGOST', method: this.showAddDialog, icon: 'mdi-beaker-plus' },
      updAction: { text: 'Редактировать элемент', actionType: 'Справочник ГОСТы по типам топлива', action: 'updGOST', method: this.showEditDialog, icon: 'mdi-beaker-check' },
      delAction: { text: 'Удалить элемент', actionType: 'Справочник ГОСТы по типам топлива', action: 'delGOST', method: this.showDelDialog, icon: 'mdi-beaker-minus' },
      selectedGOST: [],
      dlgShowAdd: false,
      dlgShowConfirm: false
    }
  },
  watch: {
    accessKey (val) {
      console.log('Called for accessKey ', val)
      if (val !== 'forms/refGOST2FTList') {
        this.$store.dispatch(UI_SET_ACTIONS, { actionType: 'Справочник ГОСТы по типам топлива' })
      } else {
        this.setActions()
      }
    }
  },
  methods: {
    setActions () {
      this.$store.dispatch(UI_SET_ACTIONS, { actionType: 'Справочник ГОСТы по типам топлива' })
      this.$store.dispatch(UI_ADD_ACTION, this.addAction)
      if (this.selectedGOST.length) {
        this.$store.dispatch(UI_ADD_ACTION, this.updAction)
        this.$store.dispatch(UI_ADD_ACTION, this.delAction)
      }
    },
    showAddDialog () {
      // console.log('showAddDialog in refGOST2FTList')
      this.selectedGOST.splice(0, 1)
      this.dlgShowAdd = true
    },
    showEditDialog () {
      // console.log('selectedGOST in refGOST2FTList is ', this.selectedGOST[0])
      this.dlgShowAdd = true
    },
    showDelDialog () {
      this.dlgShowConfirm = true
    },
    onGOSTChange (item) {
      console.log('GOST2FTList onGOSTChange fired with data', item)
      this.selectedGOST.splice(0, 1, ...item)
      this.setActions()
    },
    cancelConfirmDialog () {
      this.dlgShowConfirm = false
    },
    doDeleteFT () {
      console.log('Closing confirm dialog')
      this.dlgShowConfirm = false
      const processorPath = '/api/org/references/delGOST2FT.php'
      const payload = { ...this.selectedGOST[0] }
      axios({
        url: processorPath,
        method: 'POST',
        data: payload
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            this.selectedGOST.splice(0, 1, { action: 'delete', GOST_ID: this.selectedGOST[0].GOST_ID })
          } else {
            this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${err}` })
        })
    }
  },

  mounted () {
    console.log('GOST2FTList reference module mounted')
    this.setActions()
  }
}
</script>
